<template>
    <a :href="actionUrl" class="h-full block">
        <div class="bg-white w-full rounded-xl overflow-hidden h-full shadow-lg group border flex flex-col relative group">
            <button v-if="showBookMark" @click.prevent="toggleBookmark()" :class="['absolute top-0 right-4 z-10 hover:scale-105 duration-150 ', bookmarked ? 'text-[#FF8B8B]' : 'text-[#FFF4F4] hover:text-[#ffdddd]']">
                <BookmarkingIcon />
            </button>

            <div class="p-[12px] pb-0 flex-shrink-0">
                <div class="relative w-full overflow-hidden h-32 rounded-r-xl rounded-tl-lg">
                    <slot name="image">
                        <img alt="Avatar" class="w-full absolute h-full duration-150 object-cover group-hover:scale-105" :src="imageUrl" />
                    </slot>

                    <slot name="badge" />
                </div>
            </div>
            <div class="flex flex-col flex-1 min-h-0">
                <div class="p-4 pb-0 border-b flex-1 flex flex-col">
                    <div class="flex items-center space-x-1.5 flex-shrink-0">
                        <slot name="bands" />
                    </div>
                    <div class="flex items-center my-3 flex-shrink-0">
                        <div class="flex items-center min-h-[60px]">
                            <slot name="title" />
                        </div>
                    </div>
                    <div class="flex-shrink-0">
                        <slot name="description" />
                    </div>
                </div>
                <div class="p-4 flex items-center space-x-1.5 flex-shrink-0">
                    <slot name="tags" />
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import { AisHighlight } from "vue-instantsearch/vue3/es";
import Axios from "axios";
import { mergeContinuousLevels } from "../Helpers/Utils.js";
import PrimaryButton from "./PrimaryButton.vue";
import BookmarkingIcon from "./BookmarkingIcon";
import { usePage } from "@inertiajs/vue3";

export default {
    components: {
        AisHighlight,
        BookmarkingIcon,
        PrimaryButton,
    },
    data() {
        return {
            subjectsExpanded: false,
            topicsExpanded: false,
            bookmarked: this.isBookmarked,
        };
    },
    methods: {
        removeTags(str) {
            if (str === null || str === "") return null;
            else str = str.toString();
            return str.replace(/(<([^>]+)>)/gi, "");
        },
        async toggleBookmark() {
            if (!this.user || (typeof this.user === "object" && !this.user.id)) {
                window.location.href = route("login");
                return;
            }

            let newValue = !this.isBookmarked;
            try {
                this.bookmarked = newValue;
                await Axios.put(route(this.bookmarkRoute, this.item.id), {
                    is_bookmarked: newValue,
                }).then((resp) => resp.data);
            } catch (e) {
                console.error(e);
            } finally {
                this.$emit("bookmarkUpdated", { id: this.item.id, is_bookmarked: newValue });
            }
            //delete all of these
            // // try {
            // //     let data = await Axios.put(route('plos.bookmark', this.item.id), {
            // //         is_bookmarked: newValue
            // //     }).then(resp => resp.data);
            // // }
            // // catch (e) {
            // //     console.error(e)
            // // }
            // // finally {

            // // }
        },
    },
    computed: {
        user() {
            return usePage().props.auth.user;
        },
    },
    props: {
        item: Object,
        hitType: String,
        buttonTextColor: {
            type: String,
            defeault: "white",
        },
        isAlgoliaItem: {
            type: Boolean,
            default: true,
        },
        isBookmarked: {
            type: Boolean,
            default: false,
        },
        imageUrl: {
            type: String,
            default: "https://subjecttoclimate.nyc3.digitaloceanspaces.com/4365/conversions/adryan-ra-ysT-xbhhK2c-unsplash-thumb.jpg",
        },
        showBookMark: {
            type: Boolean,
            default: true,
        },
        bookmarkRoute: {
            type: String,
        },
        actionUrl: {
            type: String,
            default: null,
        },
    },

    setup() {
        return { mergeContinuousLevels };
    },
};
</script>
